'use strict';
import {Subject} from 'rxjs/Subject';

module.exports = [
  '$provide',
  AwsS3GatewayServiceDecorator];

function AwsS3GatewayServiceDecorator(
  $provide,
) {
  $provide.decorator('AwsS3GatewayService', [
    '$delegate',
    '$window',
    '$timeout',
    decorateService]);
}

function decorateService(
  $delegate,
  $window,
  $timeout,
) {

  if ($window.cordova) { // cordova environment
    console.log('replacing the uploader methodology for Cordova environment');
    $delegate.upload = cordovaUpload;
  } // else, web environment, do nothing

  return $delegate;

  function cordovaUpload(data) {
    console.log('uploading data in Cordova environment:', data);

    //We need to convert filename="<a name>" to filename=\"<a name>\" so that the quotation marks will be property escaped in the HTML form
    if (data.form) {
      data.form = data.form.replace('filename="', 'filename=\\"');
      data.form = data.form.replace('""', '\\""');
      console.log('modified form data:', data.form);
    }

    return uploadImplementation(data.url, data.fileUri, {
      mimeType: data.headers['Content-Type'],
      headers: data.headers,
      fileName: data.key,
      chunkedMode: false,
      encodeURI: false,
      httpMethod: 'PUT'
    }, false)
  }

  // modified version of $cordovaFileTransfer.upload to return an observable for progression
  function uploadImplementation(server, filePath, options, trustAllHosts) {
    var deferred = Promise.defer();
    var progressSubject = new Subject();
    deferred.promise.then(function () {
      progressSubject.complete();
      setTimeout(progressSubject.unsubscribe.bind(progressSubject), 150); // make sure this is cleaned up. may not be necessary
    }, function () {
      progressSubject.error();
      setTimeout(progressSubject.unsubscribe.bind(progressSubject), 150); // make sure this is cleaned up. may not be necessary
    });
    var ft = new $window.FileTransfer();
    var uri = (options && options.encodeURI === false) ? server : encodeURI(server);

    if (options && options.timeout !== undefined && options.timeout !== null) {
      $timeout(ft.abort.bind(ft), options.timeout);
      options.timeout = null;
    }

    ft.onprogress = progressSubject.next.bind(progressSubject);

    deferred.promise.abort = ft.abort.bind(ft);

    ft.upload(filePath, uri, deferred.resolve.bind(deferred), deferred.reject.bind(deferred), options, trustAllHosts);

    return {
      promise: deferred.promise,
      observable: progressSubject
    };
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/aws-api/AwsS3GatewayServiceDecorator.js